import { styled } from '../jss-style';
import skeletonStyle from './skeleton';

const useSkeletonStyle = styled(skeletonStyle, 'skeleton');
export { skeletonStyle, useSkeletonStyle };
export default useSkeletonStyle;
